import { UploadFile } from "antd"
import { SurveySection } from "../../domain/entities/SurveySection"
import { SectionQuestion } from "../../domain/entities/SectionQuestion"

interface ContructorParams {
	id?: number
	name: string
	name_en: string
	name_ca: string
	description?: string
	description_en?: string
	description_ca?: string
	image?: string | UploadFile
	questions?: SectionQuestion[]
	order?: number
}
export class SurveySectionModel {
	public readonly id?: number
	public readonly name: string
	public readonly name_en: string
	public readonly name_ca: string
	public readonly description?: string
	public readonly description_en?: string
	public readonly description_ca?: string
	public readonly image?: string | UploadFile
	public readonly questions?: SectionQuestion[]
	public readonly order?: number

	constructor(params: ContructorParams) {
		this.id = params.id
		this.name = params.name
		this.name_en = params.name_en
		this.name_ca = params.name_ca
		this.description = params.description
		this.description_en = params.description_en
		this.description_ca = params.description_ca
		this.image = params.image
		this.questions = params.questions
		this.order = params.order
	}

	static fromDomain(surveySection: SurveySection): SurveySectionModel {
		return new SurveySectionModel(surveySection)
	}

	static fromRawJson(surveySection: SurveySection): SurveySectionModel {
		return new SurveySectionModel(surveySection)
	}

	toDomain(): SurveySection {
		return new SurveySection({
			id: this.id,
			name: this.name,
			name_en: this.name_en,
			name_ca: this.name_ca,
			description: this.description,
			description_en: this.description_en,
			description_ca: this.description_ca,
			image: this.image,
			questions: this.questions,
			order: this.order
		})
	}
}
